{
	"ariaCreateNew": "Create New",
	"createNewGroup": "Create new group",
	"createNewGroupTitle": "Create New Group",
	"group": "Group:",
	"movePreset": "Move Preset",
	"newGroup": "New Group",
	"ok": "OK"
}
